import { remoteUrl, urlWithParams } from "../../helpers/UrlHelpers";

const MODS_FACTORY_URL  = process.env.REACT_APP_MODSFACTORY_URL;

function categoryPath(this: any, target_id: number, id: number ) {
  let target;

  switch (target_id) {
    case 1:
      target = 'skins';
      break;
    case 2:
      target = 'worlds';
      break;
    case 3:
      target = 'addon_templates';
      break;
    case 5:
      target = 'main_skins';
      break;
    default:
      target = '';
  }

  return `/${this.basePath}/${target}?category_id=${id}`;
}

function usersPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/users`, params);
}
function userPath(this: any, id: number) {
  return `/${this.basePath}/users/${id}`;
}

function worldsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/worlds`, params);
}
function worldPath(this: any, id: number) {
  return `/${this.basePath}/worlds/${id}`;
}

function skinsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/skins`, params);
}
function skinPath(this: any, id: number) {
  return `/${this.basePath}/skins/${id}`;
}

function mainSkinsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/main_skins`, params);
}
function mainSkinPath(this: any, id: number) {
  return `/${this.basePath}/main_skins/${id}`;
}

function addonTemplatesPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/addon_templates`, params);
}
function addonTemplatePath(this: any, id: number) {
  return `/${this.basePath}/addon_templates/${id}`;
}

function addonPath(this: any, id: number) {
  return `/${this.basePath}/addons/${id}`;
}
function addonsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/addons`, params);
}
function addonsTrendingPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/addons/trending`, params);
}
function addonsPopularPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/addons/popular`, params);
}
function addonsRecentsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/addons/recents`, params);
}

function reportsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/reports`, params);
}
function reportAddonsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/reports/addons`, params);
}
function reportUsersPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/reports/users`, params);
}
function reportCommentsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/reports/comments`, params);
}

function commentPath(this: any, comment?: any) {
  const params = { tab: 'comment', go_to_comment: comment.id };
  let targetUrl;

  switch (comment.parent_target_type) {
    case 'Addon':
      targetUrl = addonPath.call(this, comment.parent_target_id);
      break;
    case 'Skin':
      targetUrl = skinPath.call(this, comment.parent_target_id);
      break;
    case 'World':
      targetUrl = worldPath.call(this, comment.parent_target_id);
      break;
    case 'AddonTemplate':
      targetUrl = addonTemplatePath.call(this, comment.parent_target_id);
      break;
    case 'MainSkin':
      targetUrl = mainSkinPath.call(this, comment.parent_target_id);
      break;
    case 'User':
      targetUrl = userPath.call(this, comment.parent_target_id);
      break;
    default:
      targetUrl = '/404';
  }

  return targetUrl ? urlWithParams(targetUrl, params) : null;
}

const modsfactoryUrls = {
  baseURL: MODS_FACTORY_URL,
  basePath: 'mods_factory',

  remoteUrl: remoteUrl,

  addonPath:          addonPath,
  addonsPath:         addonsPath,
  addonsTrendingPath: addonsTrendingPath,
  addonsPopularPath:  addonsPopularPath,
  addonsRecentsPath:  addonsRecentsPath,

  usersPath:          usersPath,

  skinsPath:          skinsPath,
  skinPath:           skinPath,

  worldsPath:         worldsPath,
  worldPath:          worldPath,

  addonTemplatePath:  addonTemplatePath,
  addonTemplatesPath: addonTemplatesPath,

  mainSkinPath:       mainSkinPath,
  mainSkinsPath:      mainSkinsPath,

  categoryPath:       categoryPath,
  userPath:           userPath,

  reportsPath:        reportsPath,
  reportAddonsPath:   reportAddonsPath,
  reportUsersPath:    reportUsersPath,
  reportCommentsPath: reportCommentsPath,

  commentPath:        commentPath
}

export default modsfactoryUrls;
